// src/features/tower/storeReadiness/components/ReadinessGroup.tsx

import React from "react";
import type { TaskGroup, ReadinessTile as TileType } from "../types";
import { ReadinessTile } from "./ReadinessTile";

type Props = {
  group: TaskGroup;
  onTileClick: (tile: TileType) => void;
};

export function ReadinessGroup({ group, onTileClick }: Props) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginBottom: 10,
        }}
      >
        <div style={{ fontSize: 14, fontWeight: 650, color: "var(--ct-ink)" }}>
          {group.category}
        </div>
        <div style={{ fontSize: 12, color: "var(--ct-ink-3)" }}>
          {group.completedCount} / {group.totalCount} complete
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          gap: 10,
        }}
      >
        {group.tiles.map((tile) => (
          <ReadinessTile key={tile.taskDefinitionId} tile={tile} onClick={() => onTileClick(tile)} />
        ))}
      </div>
    </div>
  );
}
